var _slicedToArray = require("/Users/nakahashitakayuki/dev/works/ns-recrenewal/node_modules/@babel/runtime/helpers/slicedToArray.js");

var _require = require('react'),
    useState = _require.useState,
    useEffect = _require.useEffect;

exports.createUseBreakpoint = function (_ref) {
  var useTheme = _ref.theme;
  return function (breakpoint) {
    // Get the media query to match
    var query = breakpoint({
      theme: useTheme()
    }).replace(/^@media\s*/, '');

    var _useState = useState(null),
        _useState2 = _slicedToArray(_useState, 2),
        isBreak = _useState2[0],
        setIsBreak = _useState2[1];

    useEffect(function () {
      var mq = window.matchMedia(query);

      var handleChange = function handleChange(event) {
        setIsBreak(event.matches);
      };

      setIsBreak(mq.matches); // Safari < 14 can't use addEventListener on a MediaQueryList
      // https://developer.mozilla.org/en-US/docs/Web/API/MediaQueryList#Browser_compatibility

      if (!mq.addEventListener) {
        // Update the state whenever the media query match state changes
        mq.addListener(handleChange); // Clean up on unmount and if the query changes

        return function () {
          mq.removeListener(handleChange);
        };
      }

      mq.addEventListener('change', handleChange);
      return function () {
        mq.removeEventListener('change', handleChange);
      };
    }, [query]);
    return isBreak;
  };
};